module.exports = __webpack_public_path__ + "static/terence-tan-801d2cab611380d16abd75c4222562b4.jpg";